module.exports = __webpack_public_path__ + "static/img/account.d3e37ecf.svg";